import React, { useState, useEffect } from 'react'
import { Box, Flex, Group, Button, Input, Tabs, Text, ThemeIcon } from '@mantine/core'
import { Dropzone } from '@mantine/dropzone'
import { IconClipboardText, IconDownload, IconTrash } from '@tabler/icons-react'
import { uploadDocumentRequestQuote, deleteDocumentRequestQuote } from '../../../services/request-quote.js'
import { notificationSuccess, notificationError } from '../../ui/Notifications'
import { deleteRecentDocumentSourcingRequest } from '../../ui/Prompt/deleteRecentDocumentSourcingRequest'

const formValidation = {
  documents: {
    isError: false,
    message: ''
  }
}

const FormAttachDocument = ({ dataProductQuote, onCloseModal, reloadList }) => {
  const [selectedTab, setSelectedTab] = useState('upload-document')
  const [validationForm, setValidationForm] = useState(formValidation)
  const [uploadedDocument, setUploadedDocument] = useState([])
  const [recentDataDocument, setRecentDataDocument] = useState([])
  const [loadingForm, setLoadingForm] = useState(false)

  const submitUploadDocuments = async () => {
    setLoadingForm(true)
    let isError = false
    if (validationForm.documents.isError) {
      isError = validationForm.documents.isError
    }
    if (isError) {
      notificationError('Upload Document Product Quote Error', `${validationForm.image.message}`)
      setLoadingForm(false)
      return
    }
    const payload = {
      documents: uploadedDocument
    }
    try {
      const response = await uploadDocumentRequestQuote(dataProductQuote.id, payload)
      if (response.success) {
        onCloseModal()
        reloadList()
        notificationSuccess('Attach Document Product Quote Successfully', 'You have been add document product quote')
      }
    } catch (error) {
      console.log(error)
      const errorMessage = error.response.data.message
      const captionMessageError = Object.keys(errorMessage) ? errorMessage : 'Please recheck your form'
      notificationError('Attach Document Product Quote Error', captionMessageError)
    } finally {
      setLoadingForm(false)
    }
  }

  useEffect(() => {
    if (dataProductQuote) {
      handleChangeForm(dataProductQuote)
    }
  }, [dataProductQuote])

  const handleChangeForm = (value) => {
    const recentDataDocument = value.documents
    setRecentDataDocument(recentDataDocument)
  }

  const handleUploadDocument = (file) => {
    setValidationForm(formValidation)
    let regex = new RegExp(/\.[^/.]+$/)
    let dataDocument = {
      file_name: '',
      document_encoded: ''
    }
    const fileEncoded = file[0]
    let fileName = fileEncoded.name.replace(regex, "").toLowerCase()
    // Replace all characters that are NOT alphabet, numeric, or underscore with underscore
    let convertName = fileName.replace(/[^a-z0-9_]/g, "_")
    dataDocument.file_name = convertName
    const fileReader = new FileReader()
    fileReader.readAsDataURL(fileEncoded)
    fileReader.onload = (reader) => {
      dataDocument.document_encoded = reader.target.result.substr(reader.target.result.indexOf(',') + 1)
    }
    setUploadedDocument(oldVal => [...oldVal, dataDocument])
  }



  const handleErrorFile = (file) => {
    setValidationForm(formValidation)
    const fileState = Object.values(file)
    const errorMessage = fileState[0].errors[0].message
    if (errorMessage) {
      const error = {
        documents: {
          isError: true,
          message: errorMessage
        }
      }
      setValidationForm(error)
    }
  }

  const mappingUploadedDocument = (data) => {
    if (data.length > 0) {

      const handleRemoveUploadDocument = (filename) => {
        const remainingDocument = uploadedDocument.filter((val) => {
          return val.file_name !== filename
        })
        setUploadedDocument(remainingDocument)
      }

      const mappingDocument = (data) => {
        const remapData = data.map((val, index) => {
          return (
            <Flex justify='space-between' align='center'>
              <Text fz={13} c='gray.7'>{index + 1}. {val.file_name}</Text>
              <Group gap={4}>
                <ThemeIcon variant="white" color="red" radius='lg' size='sm' style={{ cursor: 'pointer' }} onClick={() => handleRemoveUploadDocument(val.file_name)}><IconTrash style={{ width: '70%', height: '70%' }} /></ThemeIcon>
              </Group>
            </Flex>
          )
        })
        return remapData
      }

      return (
        <Box>
          <Text fz={12} fw='500' mb='sm'>Uploaded Document</Text>
          <Box>{mappingDocument(data)}</Box>
        </Box>
      )
    }
  }

  const mappingRecentDocument = (data) => {
    if (data.length > 0) {

      const handleOpenDocument = (url) => {
        window.open(`${url}`, '_blank')
      }

      const handleRemoveRecentDocument = (val) => {
        const payload = {
          ids: [val.id]
        }
        deleteRecentDocumentSourcingRequest('document', dataProductQuote.id, payload, val.name, deleteDocumentRequestQuote, onCloseModal, reloadList)
      }

      const mappingDataDocument = (data) => {
        const remapData = data.map((val, index) => {
          return (
            <Flex justify='space-between' align='center'>
              <Text fz={13} c='gray.7'>{index + 1}. {val.name}</Text>
              <Group gap={4}>
                <ThemeIcon variant="white" color="blue" radius='lg' size='sm' style={{ cursor: 'pointer' }} onClick={() => handleOpenDocument(val.url)}><IconDownload style={{ width: '70%', height: '70%' }} /></ThemeIcon>
                <ThemeIcon variant="white" color="red" radius='lg' size='sm' style={{ cursor: 'pointer' }} onClick={() => handleRemoveRecentDocument(val)}><IconTrash style={{ width: '70%', height: '70%' }} /></ThemeIcon>
              </Group>
            </Flex>
          )
        })
        return remapData
      }

      return (
        <Box type="ordered" size='sm'>
          {mappingDataDocument(data)}
        </Box>
      )
    } else {
      return (
        <Box ta='center' my={40}>
          <Flex justify='center' mb={10}>
            <IconClipboardText size={50} color='gray' />
          </Flex>
          <Box>
            <Text fz={12} c='gray.6'>No Attachment Document</Text>
          </Box>
        </Box>
      )
    }
  }

  return (
    <Box>
      <Box mih={300} mb='md'>
        <Tabs size='xs' my={4} value={selectedTab} onChange={setSelectedTab}>
          <Tabs.List>
            <Tabs.Tab value="upload-document">Upload Document</Tabs.Tab>
            <Tabs.Tab value="recent-document">Recent Document</Tabs.Tab>
          </Tabs.List>
          <Tabs.Panel value="upload-document">
            <Input.Wrapper my={10} label='Upload Document (Optional)' size='xs'>
              <Box my={10}>
                <Dropzone
                  onDrop={(files) => handleUploadDocument(files)}
                  onReject={(files) => handleErrorFile(files)}
                  maxSize={2000000}
                >
                  <Box ta='center' my={30}>
                    <Flex justify='center' mb={10}>
                      <IconClipboardText size={50} color='gray' />
                    </Flex>
                    <Box>
                      <Text fz={12} c='blue.9'>Upload Document Here</Text>
                      <Text fz={12} c='gray.6'>All format file up to 2 MB</Text>
                    </Box>
                  </Box>
                </Dropzone>
              </Box>
            </Input.Wrapper>
            <Box my={20}>

              <Box>{mappingUploadedDocument(uploadedDocument)}</Box>
            </Box>
          </Tabs.Panel>
          <Tabs.Panel value="recent-document">
            <Box my={14}>
              <Text fz={12} fw='500' mb='sm'>Recent Documents</Text>
              <Box>
                {mappingRecentDocument(recentDataDocument)}
              </Box>
            </Box>
          </Tabs.Panel>
        </Tabs>
      </Box>
      <Box mt={20}>
        <Flex justify='flex-end'>
          <Group>
            <Button size='xs' variant="outline" onClick={onCloseModal}>Close</Button>
            <Button size='xs' loading={loadingForm} variant="filled" disabled={uploadedDocument.length === 0} onClick={() => submitUploadDocuments()}>Submit</Button>
          </Group>
        </Flex>
      </Box>
    </Box>
  )
}

export default FormAttachDocument